import { PaginatedRequestParams, PaginatedResponse } from "../../../../common/pagination";
import { PaymentTransactionRepository } from "../../data";
import { PaymentTransaction } from "../dtos";

export class PaymentTransactionService {

    private readonly repository;

    constructor() {
        this.repository = new PaymentTransactionRepository();
    }

    public search(req: PaginatedRequestParams): Promise<PaginatedResponse<PaymentTransaction>> {
        return this.repository.search(req);
    }

    /**
     * Get partner details by id
     * @param id
     */
    public getDetails(id: number): Promise<PaymentTransaction> {
        return this.repository.getDetails(id);
    }
}